import React, { useState, useEffect } from "react";

const AnnualTargetA = (props) => {
    const [check, setcheck] = useState(0)
    const getdata = async () => {
        const sendData = {
            Value: Number(props.parametersId),
            UserId: Number(props.useridd)
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Checktarget', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setcheck(data)
                })
    };

    const handlechange = async (e) => {
        const sendData = {
            Value: Number(props.parametersId),
            LangId: Number(props.useridd),
            CatgType: String(e.target.value),
            CatgId: Number(48),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Adddatarget', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    getdata()
                })

    }
    useEffect(() => {
        getdata()
    }, [])
    return (
        <tr style={{ margin:20 }}>
            {props.name}
            <input
                type="number"
                min="0"
                className="form-control"
                name="genderMale4"
                onChange={(e)=>handlechange(e)}
                style={{ textAlign: 'center' }}
                value={check}
                onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-') && evt.preventDefault()}
            />
        </tr>
    );
};

export default AnnualTargetA;
